module.exports = __webpack_public_path__ + "static/media/LineVerticalRedColor.1f95a967.svg";